<template>
  <div v-parallax-fit="parallax" class="slide-sheet">
    <img src="/themes/rise-theme/dist/images/estate/character-view/henry/05_browEnvelope.png">
  </div>
</template>

<script>
export default {
  inject: ['helpers'],
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 7500,
          end: 8500,
          fromStyle: { transform: 'translateY(-50%) translateX(100%)' },
          toStyle: { transform: 'translateY(-50%) translateX(-53%)' },
          easing: 'linear'
        },
        {
          start: 9500,
          end: 11000,
          fromStyle: { transform: 'translateY(-50%) translateX(-53%)' },
          toStyle: { transform: 'translateY(-50%) translateX(100%)' },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/henry/evidence/3.png',
          url: 'https://www.tandfonline.com/doi/abs/10.1080/10511482.2013.872160',
          link_title: {
			'en': "Lessons From Las Vegas: Housing Markets, Neighborhoods, and Distressed Single-Family Property Investors ",
			'es': 'Lecciones de Las Vegas: mercados inmobiliarios, vecindarios e inversores inmobiliarios unifamiliares en dificultades'
		  },
        }
      ],
      text: {
		'en': '"The collapse of the housing bubble and the ensuing wave of foreclosures have led to a dramatic increase in investor activity in distressed single-family markets."',
		'es': '"El colapso de la burbuja inmobiliaria y la subsiguiente ola de ejecuciones hipotecarias han llevado a un aumento dramático en la actividad de los inversores en los mercados de viviendas unifamiliares en dificultades".'
	  }
    };
    const text = {
		'en': 'Trusts shield the true identities of their owners. Shell companies are becoming an increasingly common way for landlords, even small-scale ones, to own rental properties.',
		'es': 'Los fideicomisos protegen las verdaderas identidades de sus propietarios. Las empresas ficticias se están convirtiendo en una forma cada vez más común para que los propietarios, incluso los de pequeña escala, adquieran propiedades en alquiler.'
	};

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.transform == 'translateY(-50%) translateX(-53%)') {
          self.$evidence.value = JSON.stringify(evidence);
          self.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('.slide-sheet'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
}
</script>

<style lang="scss" scoped>
.slide-sheet {
  position: absolute;
  top: 50%;
  left: 100%;
  max-width: 900px;
  width: 100%;
  transform: translateY(-50%) translateX(100%);
  transition: all 0.1s linear;
}

@media screen and (max-width: 1680px) {
  .slide-sheet {
    max-width: 850px;
    left: 108%;
  }
}
</style>
